<template>
  <div class="sponsorship-container">
    <div class="pdf-box">
      <iframe
        class="pdf-frame"
        :src="pdfUrl"
        title="ICTP 2026 Sponsorship Prospectus"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sponsorship',
  data() {
    return {
      pdfUrl: `${process.env.BASE_URL}ICTP2026_Sponsorship_Prospectus.pdf`,
    };
  },
};
</script>

<style scoped>
/* 主要容器样式 */
.sponsorship-container {
    width: 66%; /* 设置容器宽度为66% */
    margin: 0 auto; /* 水平居中对齐 */
    padding: 20px; /* 内边距 */
}

.pdf-box {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.pdf-frame {
  width: 100%;
  height: 900px;
  border: none;
}


</style>
